import Reveal from "@/components/base/Reveal";
import StarRating from "@/components/base/StarRating";
import { useReviews } from "@/hooks/useReviews";
import { useVehicles } from "@/hooks/useVehicles";

export default function ReviewsStrip() {
  const { reviews, loading, error } = useReviews(6);
  const { vehicles } = useVehicles();

  const vehicleName = (id: number | null) => {
    const found = vehicles.find((vehicle) => vehicle.id === id);
    return found ? `${found.make} ${found.model}` : "Gari trip";
  };

  return (
    <div id="reviews" className="mx-auto w-full max-w-7xl px-4 py-16 md:px-8 md:py-24">
      <Reveal className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
        <div className="max-w-2xl">
          <span className="text-sm font-medium uppercase tracking-[0.2em] text-primary-500">Rider reviews</span>
          <h2 className="mt-3 font-heading text-3xl font-semibold text-foreground-950 md:text-4xl">
            Loved by travellers and locals alike
          </h2>
        </div>
        <div className="flex items-center gap-3 rounded-xl surface-card px-5 py-3">
          <i className="ri-star-smile-line text-3xl text-primary-500"></i>
          <div>
            <p className="font-heading text-xl font-semibold text-foreground-950">4.8 / 5</p>
            <p className="text-xs text-foreground-500">from verified Gari trips</p>
          </div>
        </div>
      </Reveal>

      {error && (
        <p className="mt-8 flex items-center gap-2 rounded-lg border border-secondary-700/40 bg-secondary-950/40 px-4 py-3 text-sm text-secondary-300">
          <i className="ri-error-warning-line"></i> {error}
        </p>
      )}

      <div className="mt-12 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3">
        {loading &&
          !error &&
          Array.from({ length: 3 }).map((_, index) => (
            <div key={index} className="h-48 animate-pulse rounded-2xl border border-background-200/70 bg-background-100" />
          ))}

        {!loading &&
          reviews.map((review, index) => (
            <Reveal key={review.id} delay={(index % 3) * 120}>
              <figure className="flex h-full flex-col rounded-2xl surface-card p-6">
                <div className="flex items-center justify-between">
                  <StarRating rating={review.rating} />
                  <span className="inline-flex items-center gap-1 text-xs text-accent-400">
                    <i className="ri-checkbox-circle-fill"></i> Verified trip
                  </span>
                </div>
                <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-foreground-700">
                  &ldquo;{review.comment}&rdquo;
                </blockquote>
                <figcaption className="mt-5 flex items-center gap-3 border-t border-background-200/70 pt-4">
                  <span className="flex h-10 w-10 items-center justify-center rounded-full bg-secondary-500/25 font-heading text-sm font-semibold text-secondary-200">
                    {(review.reviewer_name || "G").charAt(0)}
                  </span>
                  <span>
                    <span className="block text-sm font-medium text-foreground-950">{review.reviewer_name}</span>
                    <span className="block text-xs text-foreground-500">{vehicleName(review.vehicle_id)}</span>
                  </span>
                </figcaption>
              </figure>
            </Reveal>
          ))}
      </div>
    </div>
  );
}